import { casesStatusUpdateApi, getAllSubscribedProfessionals, preapprovedProfessionals, raiseNotificationApi, revertApprovalApi, testEmailApi } from 'Constants';
import { Context } from 'Context/Context';
import PreapproveProfessionalsModal from 'Modals/PreapproveProfessionalsModal';
import React, { useContext, useEffect, useState } from 'react'
import { getCaseType } from 'Utils';
import PreApprovedProfessionalsList from './PreApprovedProfessionalsList';
import PreApproveAttorneysTable from './PreApproveAttorneysTable';
import InfoIcon from 'Components/Icons/InfoIcon';
import { FaCircleInfo } from 'react-icons/fa6';
import { Info } from 'lucide-react';

function PreApproved({caseDetails, 
approveProfessional,
availableProfessionals,
showPreApproveContent,
setShowPreApproveContent

}) {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <>
        
            <div className='w-full  flex flex-col h-full  border-1 border-b-1'>
               
               { availableProfessionals.length > 0 &&
                <>
                {/* <div 
                onClick={() => setShowPreApproveContent(!showPreApproveContent)}
                className='text-[17px] cursor-pointer justify-left items-center  ml-10 mt-4   relative flex font-bold text-gray-800'> Attorneys Available on QuickCaseReview.com
                <Info
                className='w-4 h-4 ml-2 '
                onMouseEnter={() => setShowInfo(true)}
                onMouseLeave={ () => setShowInfo(false)}
                />
                
                </div> */}
                <PreApproveAttorneysTable
                     profList={availableProfessionals}
                     caseDetails={caseDetails}
                     approveProfessional={approveProfessional}
 
                     />
                </>
               
               }
             
            </div>
            
            
    </>
  )
}

export default PreApproved